const vowels = ['a', 'e', 'i', 'o', 'u'];

/**
 * Returns the plural form of the label given.
 *
 * NOTE: Doesn't inlude irregular plural nouns for now.
 *
 * @param label label to be converted to its plural form.
 */
export const getPluralForm = (label: string): string => {
  const lastTwoCharacter = label.slice(-2);

  const lastCharacter = lastTwoCharacter.slice(1);
  const lastLastCharacter = lastTwoCharacter.slice(0, 1);

  if (lastCharacter === 'y') {
    if (vowels.includes(lastLastCharacter)) {
      return `${label}s`;
    }

    return `${label.slice(0, -1)}ies`;
  }

  if (lastCharacter === 'h') {
    if (lastLastCharacter === 'c' || lastLastCharacter === 's') {
      return `${label}es`;
    }
  }

  if (lastCharacter === 'x' || lastCharacter === 's') {
    return `${label}es`;
  }

  if (lastCharacter === 'f') {
    return `${label.slice(0, -1)}ves`;
  }

  if (lastLastCharacter === 'f' && lastCharacter === 'e') {
    return `${label.slice(0, -2)}ves`;
  }

  return `${label}s`;
};
